import http from "../utils/http";

// сохранить КИЗ в posting-item по documentId (Strapi v5 Content API)
export async function saveKizForItem(documentId, kizCode) {
  if (!documentId) throw new Error("Нет documentId для позиции");

  const res = await http.put(`/posting-items/${documentId}`, {
    data: { kiz_code: String(kizCode || "").trim() },
  });
  return res.data;
}

export async function saveAdditionalKizCodes(documentId, codes = []) {
  if (!documentId) throw new Error("Нет documentId для позиции");

  const payload = Array.from(new Set(codes))
    .map((code) => String(code || "").trim())
    .filter(Boolean);

  const res = await http.put(`/posting-items/${documentId}`, {
    data: { kiz_additional_codes: payload },
  });

  return res.data;
}

// вычислить общий статус КИЗ для постинга
export function computeKizStatus(items) {
  if (!items || items.length === 0) return "none";
  const allHave = items.every((i) => i.kiz_code && i.kiz_code.trim() !== "");
  return allHave ? "complete" : "none";
}

// пометить позицию как "sold" (по documentId позиции!)
export async function markItemSold(itemDocumentId) {
  if (!itemDocumentId) throw new Error("Нет documentId позиции");
  return http.put(`/posting-items/${itemDocumentId}`, {
    data: { withdrawal_status: "sold" },
  });
}

// обновить статус постинга по documentId (Strapi v5 Content API)
export async function updatePostingKizStatus(documentId, kizStatus) {
  if (!documentId) throw new Error("Нет documentId постинга");

  const res = await http.put(`/postings/${documentId}`, {
    data: { kiz_status: kizStatus },
  });
  return res.data;
}

/* ====== возвраты кизов ====== */

// сохранить признак «КИЗ возвращён» в позиции
export async function setItemReturnStatus(documentId, returned) {
  if (!documentId) throw new Error("Нет documentId для позиции");
  return http.put(`/posting-items/${documentId}`, {
    data: { kiz_returned: !!returned },
  });
}

export function computeReturnStatus(items = []) {
  if (items.length === 0) return "none";
  const allReturned = items.every((i) => !!i.kiz_returned);
  return allReturned ? "returned_all" : "need_return";
}

export async function updatePostingReturnStatus(postingDocumentId, status) {
  if (!postingDocumentId) throw new Error("Нет postingDocumentId");
  return http.put(`/postings/${postingDocumentId}`, {
    data: { return_status: status },
  });
}
/* ====== ПРоодажа кизов ====== */

// поставить статус продажи у позиции (posting-item) по documentId
export async function setItemWithdrawalStatus(documentId, status /* 'on_balance' | 'sold' */) {
  if (!documentId) throw new Error("Нет documentId позиции");
  await http.put(`/posting-items/${documentId}`, {
    data: { withdrawal_status: status },
  });
}

// посчитать агрегат по всем позициям постинга
export function computeWithdrawalStatus(items) {
  if (!items || items.length === 0) return "on_balance";
  const allSold = items.every((i) => i.withdrawal_status === "sold");
  return allSold ? "sold" : "on_balance";
}

// записать агрегат в posting (по documentId постинга!)
export async function updatePostingWithdrawalStatus(postingDocumentId, agg /* 'on_balance' | 'sold' */) {
  if (!postingDocumentId) throw new Error("Нет documentId постинга");
  await http.put(`/postings/${postingDocumentId}`, {
    data: { withdrawal_status: agg },
  });
}

export async function sendKizToWb(documentId) {
  if (!documentId) throw new Error("Нет documentId позиции");
  return http.post(`/posting-items/${documentId}/wb-send`);
}
